<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <div class="logo">📋</div>
        <h1 class="title">Tasker</h1>
        <p class="subtitle">智能规划，高效执行</p>
      </div>

      <div class="tab-switch">
        <button 
          class="tab-btn" 
          :class="{ active: isLogin }"
          @click="isLogin = true">
          登录
        </button>
        <button 
          class="tab-btn" 
          :class="{ active: !isLogin }"
          @click="isLogin = false">
          注册
        </button>
      </div>

      <!-- 登录表单 -->
      <form v-if="isLogin" @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label class="form-label">用户名</label>
          <input 
            v-model="loginForm.username" 
            type="text" 
            class="form-input"
            placeholder="请输入用户名"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label">密码</label>
          <input 
            v-model="loginForm.password" 
            type="password" 
            class="form-input"
            placeholder="请输入密码"
            required
          />
        </div>

        <button type="submit" class="btn-submit" :disabled="loading">
          {{ loading ? '登录中...' : '登录' }}
        </button>
      </form>

      <!-- 注册表单 -->
      <form v-else @submit.prevent="handleRegister" class="login-form">
        <div class="form-group">
          <label class="form-label">用户名</label>
          <input 
            v-model="registerForm.username" 
            type="text" 
            class="form-input"
            placeholder="请输入用户名"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label">密码</label>
          <input 
            v-model="registerForm.password" 
            type="password" 
            class="form-input"
            placeholder="请输入密码"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label">昵称</label>
          <input 
            v-model="registerForm.nickname" 
            type="text" 
            class="form-input"
            placeholder="请输入昵称"
          />
        </div>

        <div class="form-group">
          <label class="form-label">邮箱</label>
          <input 
            v-model="registerForm.email" 
            type="email" 
            class="form-input"
            placeholder="请输入邮箱"
          />
        </div>

        <button type="submit" class="btn-submit" :disabled="loading">
          {{ loading ? '注册中...' : '注册' }}
        </button>
      </form>

    </div>
    
    <!-- 备案信息 -->
    <div class="icp-footer">
      <p class="copyright">MIT Licensed | Copyright © 2026-present 隔壁的森森</p>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
        辽ICP备2024037152号-3
      </a>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import * as userApi from '../api/user'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const isLogin = ref(true)
    const loading = ref(false)

    const loginForm = ref({
      username: '',
      password: ''
    })

    const registerForm = ref({
      username: '',
      password: '',
      nickname: '',
      email: ''
    })

    const handleLogin = async () => {
      loading.value = true
      try {
        const res = await userApi.login(loginForm.value.username, loginForm.value.password)
        if (res.data.code === 200) {
          ElMessage.success('登录成功')
          // 保存用户信息到localStorage
          localStorage.setItem('user', JSON.stringify(res.data.data))
          router.push('/daily')
        } else {
          ElMessage.error(res.data.message || '登录失败')
        }
      } catch (error) {
        ElMessage.error('登录失败：' + (error.message || '网络错误'))
      } finally {
        loading.value = false
      }
    }

    const handleRegister = async () => {
      loading.value = true
      try {
        const res = await userApi.register(registerForm.value)
        if (res.data.code === 200) {
          ElMessage.success('注册成功，请登录')
          isLogin.value = true
          loginForm.value.username = registerForm.value.username
          loginForm.value.password = registerForm.value.password
        } else {
          ElMessage.error(res.data.message || '注册失败')
        }
      } catch (error) {
        ElMessage.error('注册失败：' + (error.message || '网络错误'))
      } finally {
        loading.value = false
      }
    }

    return {
      isLogin,
      loading,
      loginForm,
      registerForm,
      handleLogin,
      handleRegister
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #F2F2F7 0%, #E5E5EA 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', sans-serif;
}

.login-card {
  background: white;
  border-radius: 24px;
  padding: 48px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.logo {
  font-size: 64px;
  margin-bottom: 16px;
}

.title {
  font-size: 32px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0 0 8px 0;
}

.subtitle {
  font-size: 16px;
  color: #86868b;
  margin: 0;
}

.tab-switch {
  display: flex;
  gap: 8px;
  margin-bottom: 32px;
  background: #f5f5f7;
  border-radius: 12px;
  padding: 4px;
}

.tab-btn {
  flex: 1;
  padding: 12px;
  border: none;
  background: transparent;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #86868b;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-btn.active {
  background: white;
  color: #007AFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.login-form {
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e5e5e7;
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.2s;
  font-family: inherit;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #007AFF;
  box-shadow: 0 0 0 4px rgba(0, 122, 255, 0.1);
}

.btn-submit {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #007AFF 0%, #5856D6 100%);
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 122, 255, 0.4);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.test-accounts {
  background: #f5f5f7;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
}

.test-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 8px 0;
}

.test-info {
  font-size: 13px;
  color: #86868b;
  margin: 4px 0;
}

/* 备案信息 */
.icp-footer {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  line-height: 1.8;
}

.icp-footer .copyright {
  font-size: 12px;
  color: #86868b;
  margin: 0 0 4px 0;
}

.icp-footer a {
  font-size: 12px;
  color: #86868b;
  text-decoration: none;
  transition: color 0.2s;
}

.icp-footer a:hover {
  color: #007AFF;
}

@media (max-width: 480px) {
  .login-card {
    padding: 32px 24px;
  }

  .title {
    font-size: 28px;
  }

  .logo {
    font-size: 48px;
  }
  
  .icp-footer {
    bottom: 12px;
  }
  
  .icp-footer a {
    font-size: 11px;
  }
}
</style>
